<template>
  <div>
    <div class="bigBox" id="top">
      <div class="outBox">
        <div class="headBox">
          <img src="../../assets/logo.png" class="logo">
          <img src="../../assets/nav-list.png" v-show="!visible" class="list" @click='togloNav'>
          <img src="../../assets/nav-close.png" v-show="visible" class="colseBtn" @click='closeNav'>
        </div>

        <transition name="van-slide-down">
          <div class="listBoxs" v-show="visible">
            <div>
              <div class="title" @click="goHome">首页</div>
<!--              <div class="title" @click="goStars">承运通</div>-->
              <div class="title" @click="goAboutUs">关于我们</div>
              <div class="title" @click="goNews">新闻中心</div>
              <div class="title noSub" v-show="subFlag" @click="showSub">产品服务</div>
              <div class="title subContainer" v-show="!subFlag">
                <p @click="showSub">产品服务</p>
                <ul class="subBox">
                  <li class="subTitle" @click="goShipData">航运大数据</li>
                  <li class="subTitle" @click="goSupply">运输交易服务</li>
                  <li class="subTitle" @click="goLogistics">智慧物流服务</li>
                  <li class="subTitle" @click="goFinance">金融保险</li>
                  <li class="subTitle" @click="goShipManage">船舶管理</li>
                  <!--                                                <li class="subTitle" @click="goTrade">采购贸易</li>-->
                  <li class="subTitle" @click="goDataAPI">数据API</li>
                </ul>
              </div>
              <div class="title" @click="goFleet">公司船队</div>
            </div>
          </div>
        </transition>


      </div>
    </div>
    <div style="margin-top:2.75rem"></div>
    <div class="mask" v-show="visible" @click="closeNav"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      subFlag: true
    }
  },
  created() {

  },
  methods: {
    togloNav: function () {
      //切换list
      this.visible = true
    },
    showSub: function () {
      //显示子列表
      this.subFlag = !this.subFlag;
    },
    closeNav: function () {
      //关闭
      this.visible = false;
      this.subFlag = true
    },
    goHome: function () {
      //首页
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/') {
        this.subFlag = true;
        this.visible = false;

        return;
      }
      this.$router.push({
        path: '/'
      })
    },
    goStars: function () {
      //承运通
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/stars') {
        this.subFlag = true;
        this.visible = false;
        window.scrollTo(0, 0)
        return;
      }
      this.$router.push({
        path: '/stars'
      })
    },
    goAboutUs: function () {
      //关于我们
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/aboutUs') {
        this.subFlag = true;
        this.visible = false;
        window.scrollTo(0, 0)
        return;
      }
      this.$router.push({
        path: '/aboutUs'
      })
    },
    goSupply: function () {
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/supplyChain') {
        this.subFlag = true;
        this.visible = false;
        window.scrollTo(0, 0)
        return;
      }
      this.$router.push({
        path: '/supplyChain'
      })
    },
    goLogistics: function () {
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/logistics') {
        this.subFlag = true;
        this.visible = false;
        window.scrollTo(0, 0)
        return;
      }
      this.$router.push({
        path: '/logistics'
      })
    },
    goShipData: function () {
      //船舶大数据
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/shipData') {
        this.subFlag = true;
        this.visible = false;
        window.scrollTo(0, 0)
        return;
      }
      this.$router.push({
        path: '/shipData'
      })
    },
    goShipManage: function () {
      //船舶管理
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/shipManage') {
        this.subFlag = true;
        this.visible = false;
        window.scrollTo(0, 0)
        return;
      }
      this.$router.push({
        path: '/shipManage'
      })
    },
    goDataAPI: function () {
      //船舶管理
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/dataApi') {
        this.subFlag = true;
        this.visible = false;
        window.scrollTo(0, 0)
        return;
      }
      this.$router.push({
        path: '/dataApi'
      })
    },
    goTrade: function () {
      //船舶管理
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/trade') {
        this.subFlag = true;
        this.visible = false;
        window.scrollTo(0, 0)
        return;
      }
      this.$router.push({
        path: '/trade'
      })
    },
    goFinance: function () {
      //金融保险
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/finance') {
        this.subFlag = true;
        this.visible = false;
        window.scrollTo(0, 0)
        return;
      }
      this.$router.push({
        path: '/finance'
      })
    },
    goFleet: function () {
      //公司船队
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/fleet') {
        this.subFlag = true;
        this.visible = false;
        window.scrollTo(0, 0)
        return;
      }
      this.$router.push({
        path: '/fleet'
      })
    },
    goNews: function () {
      //新闻中心
      window.scrollTo(0, 0)
      var path = this.$route.path;
      if (path == '/news') {
        this.subFlag = true;
        this.visible = false;
        this.$router.go(0);
        window.scrollTo(0, 0)
        return;
      }
      this.$router.push({
        path: '/news'
      })
    }

  }
}
</script>
<style lang='less' rel='stylesheet/less'>
@rem: 16rem;
@col-f: #fff;
@col-sub: #A7A7A7;
.bigBox {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;

  .outBox {

    padding-left: 12/@rem;
    padding-right: 12/@rem;
    background: #272D38;
    position: relative;

    .headBox {
      display: flex;
      justify-content: space-between;
      width: 100%;

      height: 44/@rem;
      align-items: center;

      .logo {
        width: 3.825rem;
        height: 1.625rem;
      }

      .list {
        width: 22/@rem;
        height: 18/@rem;
      }

      .colseBtn {
        width: 18/@rem;
        height: 18/@rem;
      }
    }

    .listBoxs {
      position: absolute;
      left: 0;
      top: 44/@rem;
      width: 100%;

      background: #000;

      .title {
        padding-left: 12/@rem;
        padding-right: 12/@rem;
        color: @col-f;
        font-size: 14/@rem;
        line-height: 50/@rem;
        margin: 0;
        border-bottom: 1px solid rgba(48, 50, 54, 1);
        font-weight: 300
      }

      .noSub {
        background-image: url('../../assets/nav-arrow-down.png');
        background-size: 12/@rem 6/@rem;
        background-position: 96% center;
        background-repeat: no-repeat
      }

      .subContainer {
        p {
          margin: 0;
          background-image: url('../../assets/nav-arrow-up.png');
          background-size: 12/@rem 6/@rem;
          background-position: right center;
          background-repeat: no-repeat
        }

        .subBox {
          font-size: 13/@rem;
          color: @col-sub;
          padding-left: 14/@rem;
          line-height: 30/@rem;
        }
      }

    }
  }
}

.mask {
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  z-index: 66;
  left: 0;
  bottom: 0
}
</style>



// WEBPACK FOOTER //
// src/components/nav/head.vue